import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import styles from "../cssmodules/sidebar.module.css";
import Header from "./Header";
import { logoutSuccess } from "../redux-toolkit/slices/authSlice";
import { fingerprintVerifyReset } from "../redux-toolkit/slices/fingerPrintSlice";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";

// Computer Operators who also get Welfare Fees access (matched by userName)
const WELFARE_OPERATORS = ["pradeep mantriyan"];

const isWelfareOperator = (user) =>
  user?.role === "Computer Operator" &&
  WELFARE_OPERATORS.includes(String(user?.userName ?? "").trim().toLowerCase());

const Sidebar = () => {
  const [isActive, setIsActive] = useState(false);
  const [activeLink, setActiveLink] = useState("Dashboard");
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1320);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => {
    setIsActive(!isActive);
  };

  const handleLinkClick = (linkName) => {
    setActiveLink(linkName);
  };

  const styleAnchor = {
    textDecoration: "none",
  };

  const userData = useSelector((state) => state.auth.userData.authUser);
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
  const isFingerPrintVerified = useSelector(
    (state) => state.fingerprint?.isFingerprintVerified
  );

  console.log("Router Page User Login Status", isLoggedIn);
  console.log("Router Page User User Data", userData);
  console.log("Router Page User FingerPrint Status", isFingerPrintVerified);
  console.log("Is Welfare Operator", isWelfareOperator(userData));

  const handleLogout = () => {
    console.log("handle logout clicked");
    dispatch(logoutSuccess());
    dispatch(fingerprintVerifyReset());
    navigate("/");
  };

  useEffect(() => {
    const path = location.pathname;
    console.log("path name of sidebar", path);
    const linkName = path === "/Dashboard" ? "Dashboard" : path.substring(1);
    setActiveLink(linkName.charAt(0).toUpperCase() + linkName.slice(1));
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1320);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <div className={`${styles["l-navbar"]} ${isActive ? styles.active : ""}`}>
        <nav className={styles.nav}>
          <div>
            <div className={styles.nav_list}>
              
                <a style={styleAnchor}
                className={`${styles.nav_logo} ${styles.header_toggle}`}
                onClick={toggleSidebar}
              >
                <i
                  className={isActive ? "bx bx-x" : "bx bx-menu"}
                  id="header-toggle"
                ></i>
                <span style={{ fontSize: "1rem" }} className={styles.nav_name}>
                  Menu
                </span>
              </a>

              {userData.role === "Super Admin" && (
                <>
                  <Link
                    style={styleAnchor}
                    to="/Dashboard"
                    className={`${styles.nav_link} ${
                      activeLink === "Dashboard" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Dashboard")}
                  >
                    <i className="ri-dashboard-fill"></i>
                    <span className={styles.nav_name}>Dashboard</span>
                  </Link>
                  <Link
                    style={styleAnchor}
                    to="/Fees"
                    className={`${styles.nav_link} ${
                      activeLink === "Fees" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Fees")}
                  >
                    <i className="ri-money-rupee-circle-fill"></i>
                    <span className={styles.nav_name}>Fees</span>
                  </Link>
                  <Link
                    style={styleAnchor}
                    to="/Verification"
                    className={`${styles.nav_link} ${
                      activeLink === "Verification" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Verification")}
                  >
                    <i className="ri-shield-user-fill"></i>
                    <span className={styles.nav_name}>Verification</span>
                  </Link>
                  <Link
                    style={styleAnchor}
                    to="/DocumentVerification"
                    className={`${styles.nav_link} ${
                      activeLink === "DocumentVerification" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("DocumentVerification")}
                  >
                    <i className="ri-folder-6-fill"></i>
                    <span className={styles.nav_name}>Documents</span>
                  </Link>
                  <Link
                    style={styleAnchor}
                    to="/Accounts"
                    className={`${styles.nav_link} ${
                      activeLink === "Accounts" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Accounts")}
                  >
                    <i className="ri-calculator-fill"></i>
                    <span className={styles.nav_name}>Accounts</span>
                  </Link>
                  <Link
                    style={styleAnchor}
                    to="/Voting"
                    className={`${styles.nav_link} ${
                      activeLink === "Voting" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Voting")}
                  >
                    <i className="ri-award-fill"></i>
                    <span className={styles.nav_name}>Voting</span>
                  </Link>
                </>
              )}

              {userData.role === "Cashier" && (
                <>
                  <Link
                    style={styleAnchor}
                    to="/Accounts"
                    className={`${styles.nav_link} ${
                      activeLink === "Accounts" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Accounts")}
                  >
                    <i className="ri-calculator-fill"></i>
                    <span className={styles.nav_name}>Accounts</span>
                  </Link>
                </>
              )}

              {userData.role === "Accountant" && (
                <>
                  <Link
                    style={styleAnchor}
                    to="/Fees"
                    className={`${styles.nav_link} ${
                      activeLink === "Fees" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Fees")}
                  >
                    <i className="ri-money-rupee-circle-fill"></i>
                    <span className={styles.nav_name}>Fees</span>
                  </Link>
                </>
              )}

              {userData.role === "Computer Operator" && (
                <>
                  <Link
                    style={styleAnchor}
                    to="/Verification"
                    className={`${styles.nav_link} ${
                      activeLink === "Verification" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("Verification")}
                  >
                    <i className="ri-shield-user-fill"></i>
                    <span className={styles.nav_name}>Verification</span>
                  </Link>
                  <Link
                    style={styleAnchor}
                    to="/DocumentVerification"
                    className={`${styles.nav_link} ${
                      activeLink === "DocumentVerification" ? styles.active : ""
                    }`}
                    onClick={() => handleLinkClick("DocumentVerification")}
                  >
                    <i className="ri-folder-6-fill"></i>
                    <span className={styles.nav_name}>Documents</span>
                  </Link>

                  {isWelfareOperator(userData) && (
                    <Link
                      style={styleAnchor}
                      to="/WelfareFees"
                      className={`${styles.nav_link} ${
                        activeLink === "WelfareFees" ? styles.active : ""
                      }`}
                      onClick={() => handleLinkClick("WelfareFees")}
                    >
                      <i className="ri-hand-heart-fill"></i>
                      <span className={styles.nav_name}>Welfare Fees</span>
                    </Link>
                  )}
                </>
              )}
            </div>
          </div>

          <div>
            {isWideScreen && userData.role === "Super Admin" && (
              <a style={styleAnchor} href="#" className={styles.nav_link}>
                <i className="ri-account-circle-fill"></i>
                <span className={styles.nav_name}>{userData?.userName}</span>
              </a>
            )}
            {userData.role !== "Super Admin" && (
              <a style={styleAnchor} href="#" className={styles.nav_link}>
                <i className="ri-account-circle-fill"></i>
                <span className={styles.nav_name}>{userData?.userName}</span>
              </a>
            )}

            
              <a style={styleAnchor}
              href="#"
              className={styles.nav_link}
              onClick={handleLogout}
            >
              <i className="bx bx-log-out nav_icon"></i>
              <span className={styles.nav_name}>SignOut</span>
            </a>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;